<template>
	<div>
		<div class="sv-tabs horizontal-center bold18 mb-20">
			<div class="sv-tab" @click="isTeam = false">
				メンバー検索
				<hr class="sv-tab-underline" :style="{ 'visibility': isMemberTabUnderlineVisible }"/>
			</div>

			<div class="sv-tab" @click="isTeam = true">
				チーム一覧
				<hr class="sv-tab-underline" :style="{ 'visibility': isTeamTabUnderlineVisible }"/>
			</div>
		</div>

		<div v-show="!isTeam" class="tab-contents">
			<div v-show="recentStaffs.length > 0" class="mb-20 tm" style="font-size: 18px">よく贈るメンバー</div>
			<div class="list-card-wrap">
				<component :is="listCardComponent" class="mb-10" v-for="(row, index) in recentStaffs" :key="'staffCard' + index" :data="row" @avatar-click="onStaffAvatarClick"></component>
				<div v-for="n in recentStaffDummy" class="dummy" :key="'recentStaffDummy' + n"></div>
			</div>

			<div class="mb-20 mt-50 tm" style="font-size: 18px">メンバーを検索します。<br>条件を入力してください。<br>※五十音順</div>

			<div class="mb-10 bold18 tm">所属</div>

			<b-select class="mb-15" v-model="teamId">
				<option value="">所属を選択する</option>
				<option
					v-for="row in teamOptions"
					:value="row.id"
					:key="row.id">
					{{ row.name }}
				</option>
			</b-select>

			<div class="mb-10 bold18 tm">名前</div>

			<input type="text" class="sv-input mb-30" v-model="name"/>

			<b-button type="is-success" class="max-w-button mb-30" :loading="isSearchLoading" @click="onSearchButtonClick">
				<div class="horizontal-center-center button-icon-right">
					<span>検索</span><img :src="require('@/assets/icons/search.svg')">
				</div>
			</b-button>

			<div v-if="staffs.length > 0" class="list-card-wrap">
				<list-card class="mb-10" v-for="(row, index) in staffs" :key="'staffCard' + index" :data="row" @avatar-click="onStaffAvatarClick"></list-card>
				<div v-for="n in staffDummy" class="dummy" :key="'staffDummy' + n"></div>
			</div>
			<div v-else class="tm">見つかりませんでした</div>
		</div>

		<div v-show="isTeam" class="tab-contents">
			<div v-show="recentTeams.length > 0" class="mb-20 tm" style="font-size: 18px">よく贈るチーム</div>
			<div class="list-card-wrap">
				<component :is="listCardComponent" class="mb-10" v-for="(row, index) in recentTeams" :key="'teamCard' + index" :isTeam="true" :data="row" @avatar-click="onTeamAvatarClick"></component>
				<div v-for="n in recentTeamDummy" class="dummy" :key="'recentTeamDummy' + n"></div>
			</div>

			<div class="mt-50 mb-20 tm" style="font-size: 18px">チームを検索します。<br>条件を入力してください。<br>※五十音順</div>

			<div class="mb-10 bold18 tm">チーム名</div>

			<input type="text" class="sv-input mb-30" v-model="teamName"/>

			<b-button type="is-success" class="max-w-button mb-30" :loading="isTeamSearchLoading" @click="onTeamSearchButtonClick">
				<div class="horizontal-center-center button-icon-right">
					<span>検索</span><img :src="require('@/assets/icons/search.svg')">
				</div>
			</b-button>

			<div class="list-card-wrap">
				<component :is="listCardComponent" class="mb-10" v-for="(row, index) in teams" :key="'teamCard' + index" :isTeam="true" :data="row" @avatar-click="onTeamAvatarClick"></component>
				<div v-for="n in teamDummy" class="dummy" :key="'teamDummy' + n"></div>
			</div>
		</div>
	</div>
</template>

<script>
import ListCard from '@/components/ListCard'
import { mapState } from 'vuex'

export default {
	name: 'CoinPresent',
	components: {
		ListCard,
	},
	data () {
		return {
			teamId: '',
			isTeam: false,
			teamOptions: [],
			teams: [],
			recentTeams: [],
			staffs: [],
			recentStaffs: [],
			name: '',
			teamName: '',
			isSearchLoading: false,
			isTeamSearchLoading: false,
			listCardComponent: null,
			staffDummy: 0,
			teamDummy: 0,
			recentStaffDummy: 0,
			recentTeamDummy: 0,
		}
	},
	created() {
	},
	mounted() {
		this.init();
	},
	computed: {
		...mapState([
			'isCurrentCoinPresentStateStored',
			'coinPresent',
		]),
		isMemberTabUnderlineVisible: function() {
			return this.isTeam ? 'hidden' : 'visible';
		},
		isTeamTabUnderlineVisible: function() {
			return this.isTeam ? 'visible' : 'hidden';
		},
	},
	methods: {
		onStaffAvatarClick: function(id) {
			this.$utils.log('onStaffAvatarClick');
			this.$utils.log(id);
			this.storeState();
			this.$router.push({ name: 'staff', params: { staffId : id, token: this.$consts.DUMMY_TOKEN }});
		},
		onTeamAvatarClick: function(id) {
			this.storeState();
			this.$router.push({ name: 'team', params: { teamId: id }});
		},
		storeState: function() {
			let data = {
				teamId: this.teamId,
				isTeam: this.isTeam,
				teamOptions: this.teamOptions,
				teams: this.teams,
				staffs: this.staffs,
				recentTeams: this.recentTeams,
				recentStaffs: this.recentStaffs,
				name: this.name,
				teamName: this.teamName,
				staffDummy: this.staffDummy,
				teamDummy: this.teamDummy,
				recentStaffDummy: this.recentStaffDummy,
				recentTeamDummy: this.recentTeamDummy,
			};
			this.$store.commit('basic', {
				key: 'isCurrentCoinPresentStateStored',
				value: true
			});
			this.$store.commit('basic', {
				key: 'coinPresent',
				value: data
			});
		},
		onSearchButtonClick: async function() {
			this.isSearchLoading = true;

			let ep = `staffs/search?team_id=${this.teamId}&name=${this.name}`;
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.staffs = res.data.staffs;
				this.setDummy();
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isSearchLoading = false;
			}
		},
		onTeamSearchButtonClick: async function() {
			this.isTeamSearchLoading = true;

			let ep = `staffs/team-search?name=${this.teamName}`;
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.teams = res.data.teams;
				this.setDummy();
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isTeamSearchLoading = false;
			}
		},
		setDummy: function() {
			if (this.$utils.isSp()) return;
			let colMax = 3;
			this.staffDummy = this.staffs.length === 0 ? 0 : colMax - (this.staffs.length % colMax);
			this.teamDummy = this.teams.length === 0 ? 0 : colMax - (this.teams.length % colMax);
			this.recentStaffDummy = this.recentStaffs.length === 0 ? 0 : colMax - (this.recentStaffs.length % colMax);
			this.recentTeamDummy = this.recentTeams.length === 0 ? 0 : colMax - (this.recentTeams.length % colMax);

		},
		init: function() {
			if (this.isCurrentCoinPresentStateStored) {
				this.teamId = this.coinPresent.teamId;
				this.isTeam = this.coinPresent.isTeam;
				this.teamOptions = this.coinPresent.teamOptions;
				this.teams = this.coinPresent.teams;
				this.staffs = this.coinPresent.staffs;
				this.recentTeams = this.coinPresent.recentTeams;
				this.recentStaffs = this.coinPresent.recentStaffs;
				this.name = this.coinPresent.name;
				this.teamName = this.coinPresent.teamName;
				this.staffDummy = this.coinPresent.staffDummy;
				this.teamDummy = this.coinPresent.teamDummy;
				this.recentStaffDummy = this.coinPresent.recentStaffDummy;
				this.recentTeamDummy = this.coinPresent.recentTeamDummy;
				this.listCardComponent = 'list-card';
			} else {
				this.getData();
			}
		},
		getData: async function() {
			let loader = this.$buefy.loading.open();
			let ep = 'staffs/screen-for-search';
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.staffs = res.data.staffs;
				this.teams = res.data.teams;
				this.recentTeams = res.data.recent_teams;
				this.recentStaffs = res.data.recent_staffs;
				this.setDummy();
				this.teamOptions = res.data.team_options;
				this.listCardComponent = 'list-card';
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loader.close();
			}
		},
	}
}
</script>

<style lang="scss" scoped>
@import '@/scss/_vars.scss';

.sv-tabs {
	justify-content: space-around;
	color: $brown;

	.sv-tab {
		cursor: pointer;

		hr.sv-tab-underline {
			background: $primary;
			height: 5px;
			width: 50px;
			margin: 5px auto 0;
			border-radius: 10px;
		}
	}
}

@media screen and (min-width: $breakPoint) {
	.list-card-wrap {
		display: flex;
		justify-content: space-around;
		flex-wrap: wrap;
		align-items: baseline;

		.dummy {
			width: 380px;
		}
	}
}
</style>
